import React, { ReactElement, ReactNode } from 'react'
import { Box, Typography } from '@material-ui/core'
import { CircularProgress } from '@material-ui/core'
import { CircularProgressWithLabel } from '../../circularProgressWithLabel'

type AllowedLoaderTypes = ReactElement<typeof CircularProgress> | ReactElement<typeof CircularProgressWithLabel>

interface LoaderWithTextProps {
  text: string | ReactNode

  children: AllowedLoaderTypes

  className?: string
}

export const LoaderWithText: React.FC<LoaderWithTextProps> = ({text, children, className}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" className={className}>
      {children}
      <Typography color="textSecondary" style={{marginTop: 12, fontSize: 16, textAlign: 'center'}}>
        {text}
      </Typography>
    </Box>
  )
}
